/**
 * 8K Brainzr brand mark, served as an image (`/logo.png`). Used both as
 * an inline header lockup and as a poster fallback when a stream has no
 * artwork. The `orientation` prop is kept for back-compat with poster-
 * card callers; the image is laid out internally so orientation is
 * effectively cosmetic now — callers should set sizing via `className`.
 */
interface Props {
  className?: string;
  orientation?: "auto" | "row" | "stack";
  alt?: string;
}

export function Logo({ className, orientation, alt = "8K Brainzr" }: Props) {
  void orientation; // retained for back-compat
  return (
    <img
      src="/logo.png"
      alt={alt}
      draggable={false}
      className={`select-none pointer-events-none object-contain ${className ?? "h-10 w-auto"}`}
    />
  );
}
